import { Component, Inject, OnInit } from '@angular/core';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { MatDialog } from '@angular/material/dialog';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { Condition, Operator, TableOption } from '../../components/kiene-table/table-option';
import { Router } from '@angular/router';
import {
    DateTableColumn,
    KieneBooleanTableColumn,
    PdfTableColumn,
    StatusTableColumn,
    TableColumn,
} from '../../components/kiene-table/table-column';
import { ConfirmDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { ChangeCurrentClientService } from '../../administration/client/change-current-client/change-current-client.service';
import { Client } from '../../../../projects/kiene-core/src/lib/components/client/classes/client';
import {
    FilterItem,
    FilterItemType,
} from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { bspRindSetSkipPlanOeffnenBestaetigung } from '../bio-sicherheits-plan-rind/bsp-rind-open-confirm';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'kiene-bio-sicherheits-plan-rind-uebersicht',
    templateUrl: './bio-sicherheits-plan-rind-uebersicht.component.html',
    styleUrls: ['./bio-sicherheits-plan-rind-uebersicht.component.scss'],
})
export class BioSicherheitsPlanRindUebersichtComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private readonly messageService: MessageService,
        private readonly api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly router: Router,
        private readonly localStorageService: LocalStorageService,
        private readonly currentClientService: ChangeCurrentClientService,
        private readonly pdf: PdfViewerDesktopService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Bio-Sicherheitspläne Rind';
        this.tableDescriptor.uniqueIdentifier = 'Bio-Sicherheitsplaene Rind';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'biosicherheitsplan_rind/';
        this.tableDescriptor.route = '/belege/biosicherheitsplanrind/';
        this.tableDescriptor.nameOfIdField = 'bs_id';
        this.tableDescriptor.searchPlaceholder = 'Bio-Sicherheitspläne Rind durchsuchen';
        this.tableDescriptor.initialSortColumn = 'bs_id';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.sendCurrentClient = true;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetailsVoid = this.gotoDetails.bind(this);
        this.tableDescriptor.addVoid = this.addPlan.bind(this);

        this.tableDescriptor.columns.push(new TableColumn('bs_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('vvvo', 'Kunde VVVO'));
        this.tableDescriptor.columns.push(new TableColumn('kunde', 'Kunde'));
        this.tableDescriptor.columns.push(new TableColumn('zusatz', 'Zusatz'));
        this.tableDescriptor.columns.push(new TableColumn('tierarzt', 'Tierarzt'));
        const valueColorMap = new Map<number, string>();
        valueColorMap.set(231, '#ff9100');
        valueColorMap.set(232, '#198f13');
        valueColorMap.set(250, '#03a5fc');
        valueColorMap.set(251, '#9c27b0');
        valueColorMap.set(252, '#1565c0');
        this.tableDescriptor.columns.push(new StatusTableColumn('status', 'Status', valueColorMap));
        this.tableDescriptor.columns.push(new PdfTableColumn('abschluss_bsd_id', 'PDF', this.showPdf.bind(this)));
        this.tableDescriptor.columns.push(new KieneBooleanTableColumn('unterschrift_kunde', 'Unterschrieben'));
        this.tableDescriptor.columns.push(new DateTableColumn('editiert', 'Editiert am'));
        this.tableDescriptor.columns.push(new TableColumn('editiert_von', 'Editiert von'));

        this.tableDescriptor.options.push(
            new TableOption(this.reopen.bind(this), 'wieder öffnen', 'lock_reset', 110025, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.duplicatePlan.bind(this), 'duplizieren', 'file_copy', 110021),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.deletePlan.bind(this), 'löschen', 'delete', 110023, {
                conditions: [new Condition('status_id', Operator.GLEICH, 231)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.beantragt.bind(this), 'TSK beantragt', 'check', 110026, {
                conditions: [new Condition('status_id', Operator.GLEICH, 232)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.nichtBeantragt.bind(this), 'TSK nicht beantragt', 'undo', 110026, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.bezahlt.bind(this), 'TSK bezahlt', 'check_circle', 110026, {
                conditions: [new Condition('status_id', Operator.GLEICH, 250)],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.zurueckAufErstellt.bind(this), 'Zurück auf erstellt', 'undo', 110026, {
                conditions: [new Condition('status_id', Operator.GLEICH, 251)],
            }),
        );
        if (this.localStorageService.currentUserIsAdmin()) {
            this.tableDescriptor.options.push(
                new TableOption(this.regeneratePdf.bind(this), 'PDF neu generieren', 'picture_as_pdf', 0),
            );
        }
        if (
            this.localStorageService.isCurrentUserKundeAdmin() ||
            this.localStorageService.isCurrentUserViehhaendlerAdmin()
        ) {
            this.tableDescriptor.options.push(
                new TableOption(this.sign.bind(this), 'unterschreiben', 'draw', 110027, {
                    conditions: [
                        new Condition('unterschrift_kunde', Operator.KLEINER, 1),
                        new Condition('tierarzt_id', Operator.EXISTIERT, null),
                    ],
                }),
            );
        }

        this.tableDescriptor.permissionView = 110020;
        this.tableDescriptor.permissionCreate = 110021;

        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: erstellt', 231, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: abgeschlossen', 232, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK beantragt', 250, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: TSK bezahlt', 251, FilterItemType.CHECKBOX, 'status_id', true),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Status: In Bearbeitung', 252, FilterItemType.CHECKBOX, 'status_id', true),
        );
    }

    gotoDetails(bsp: any) {
        if (!this.canOpenPlan()) {
            this.messageService.hintMessage('Keine Berechtigung zum Öffnen des Biosicherheitsplans.');
            return;
        }
        this.router.navigate(['belege/biosicherheitsplanrind/' + bsp.bs_id]).then();
    }

    private canOpenPlan(): boolean {
        return (
            this.localStorageService.hasPermission(110020) ||
            this.localStorageService.hasPermission(110022) ||
            this.localStorageService.hasPermission(110025)
        );
    }

    addPlan() {
        const client = this.localStorageService.getCurrentClient();
        if (!client) {
            this.currentClientService.openChangeDialog({ nurRinderbetriebe: true }).subscribe({
                next: (c: Client) => c && this.addPlan(),
            });
            return;
        }
        if (!LocalStorageService.isClientRind(client)) {
            this.messageService.hintMessage(
                'Ausgewählter Betrieb ist kein Rinder-Betrieb. Bitte wählen Sie einen gültigen Betrieb aus.',
            );
            return;
        }
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind/ensure_plan.php', { kunde_id: client.kunde_id }).subscribe({
            next: (res: { bs_id?: number; already_exists?: boolean }) => {
                if (!res?.bs_id) {
                    this.messageService.errorMessage('Plan konnte nicht angelegt oder geladen werden.', null);
                    return;
                }
                if (res.already_exists) {
                    this.messageService.hintMessage(
                        'Für diesen Kunden existiert bereits ein Biosicherheitsplan. Der bestehende Plan wird geöffnet.',
                    );
                }
                bspRindSetSkipPlanOeffnenBestaetigung(res.bs_id);
                this.router.navigate(['belege/biosicherheitsplanrind/' + res.bs_id]).then();
            },
            error: err => this.messageService.errorMessage('Fehler beim Anlegen oder Laden des Plans.', err),
        });
    }

    beantragt(bsp: any) {
        this.statusAendern(bsp, 250);
    }

    nichtBeantragt(bsp: any) {
        this.statusAendern(bsp, 232);
    }

    bezahlt(bsp: any) {
        this.statusAendern(bsp, 251);
    }

    zurueckAufErstellt(bsp: any) {
        this.statusAendern(bsp, 231);
    }

    sign(bsp: any) {
        this.api.updateEntity(this.apiBaseUrl + 'biosicherheitsplan_rind/update_unterschrift.php', bsp).subscribe({
            next: () => this.api.reload(),
            error: err => this.messageService.errorMessage('Fehler!', err),
        });
    }

    private showPdf(bsp: any) {
        const bsdId = Number(bsp?.abschluss_bsd_id || 0);
        if (!bsdId) {
            this.messageService.hintMessage('Für diesen Plan ist noch kein Abschluss-PDF vorhanden.');
            return;
        }
        const input = new PdfViewerDialogInput(
            'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php',
            new HttpParams().set('bs_id', String(bsp?.bs_id || 0)),
            'Bio-Sicherheitsplan Rind ' + (bsp?.bs_id ?? ''),
            { email: { sende_mail: true, kunde_id: bsp?.kunde_id } },
        );
        this.pdf.openPdfViewer(input);
    }

    private regeneratePdf(bsp: any): void {
        const bsId = Number(bsp?.bs_id || 0);
        if (!bsId) {
            this.messageService.hintMessage('Ungültige Plan-ID.');
            return;
        }
        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind/regenerate_pdf.php', { bs_id: bsId }).subscribe({
            next: (res: any) => {
                this.messageService.infoMessage('PDF wurde neu generiert.');
                this.api.reload();
                const bsdId = Number(res?.bsd_id || 0);
                if (bsdId > 0) {
                    const input = new PdfViewerDialogInput(
                        'biosicherheitsplan_rind_dokuments/read_or_mail_pdf.php',
                        new HttpParams().set('bs_id', String(bsId)),
                        'Bio-Sicherheitsplan Rind ' + bsId,
                        { email: { sende_mail: true, kunde_id: bsp?.kunde_id } },
                    );
                    this.pdf.openPdfViewer(input);
                }
            },
            error: err => this.messageService.errorMessage('PDF konnte nicht neu generiert werden.', err),
        });
    }

    private statusAendern(bsp: any, status_id: number) {
        bsp.status_id = status_id;
        this.api.updateEntity(this.apiBaseUrl + 'biosicherheitsplan_rind/beantragt.php', bsp).subscribe({
            next: () => this.api.reload(),
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.api.reload();
            },
        });
    }

    deletePlan(bsp: any) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bio-Sicherheitsplan-Rind löschen';
        input.text = 'Möchten Sie den Plan wirklich löschen?';
        input.okButton = 'Löschen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        this.api.deleteEntity(this.apiBaseUrl + 'biosicherheitsplan_rind/delete.php', bsp).subscribe({
                            next: () => this.api.reload(),
                            error: error =>
                                this.messageService.errorMessage(
                                    'Fehler beim Löschen des Bio-Sicherheitsplans',
                                    error,
                                ),
                        });
                    }
                },
            });
    }

    reopen(bsp: any) {
        const inputFreigabe = new ConfirmDialogInput();
        inputFreigabe.headline = 'Plan wieder freigeben';
        inputFreigabe.text = 'Möchten Sie den Biosicherheitsplan wieder zur Bearbeitung freigeben?';
        inputFreigabe.okButton = 'Ja';
        inputFreigabe.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: inputFreigabe })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        bsp.status_id = 231;
                        this.api.post(this.apiBaseUrl + 'biosicherheitsplan_rind/update.php', bsp).subscribe({
                            next: () => {
                                this.api.reload();
                                const inputOeffnen = new ConfirmDialogInput();
                                inputOeffnen.headline = 'Plan öffnen';
                                inputOeffnen.text = 'Möchten Sie den Plan nun öffnen?';
                                inputOeffnen.okButton = 'Ja';
                                inputOeffnen.cancelButton = 'Nein';
                                this.dialog
                                    .open(ConfirmDialogComponent, { data: inputOeffnen })
                                    .afterClosed()
                                    .subscribe((rOeffnen: ConfirmDialogResult) => {
                                        if (rOeffnen?.ok && rOeffnen?.confirmed) {
                                            bspRindSetSkipPlanOeffnenBestaetigung(bsp.bs_id);
                                            this.router
                                                .navigate(['belege/biosicherheitsplanrind/' + bsp.bs_id])
                                                .then();
                                        }
                                    });
                            },
                            error: error => this.messageService.errorMessage('Fehler beim Ändern des Status', error),
                        });
                    }
                },
            });
    }

    private duplicatePlan(value: any) {
        const input = new ConfirmDialogInput();
        input.headline = 'Bio-Sicherheitsplan-Rind duplizieren';
        input.text = 'Möchten Sie den Plan wirklich duplizieren und anschließend den Zielbetrieb auswählen?';
        input.okButton = 'Ja';
        input.cancelButton = 'Abbrechen';
        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (response: ConfirmDialogResult) => {
                    if (response?.ok && response?.confirmed) {
                        this.currentClientService.openChangeDialog({ nurRinderbetriebe: true }).subscribe({
                            next: (client: Client) => {
                                if (!client?.kunde_id) {
                                    return;
                                }
                                if (!LocalStorageService.isClientRind(client)) {
                                    this.messageService.hintMessage(
                                        'Ausgewählter Betrieb ist kein Rinder-Betrieb. Bitte wählen Sie einen gültigen Betrieb aus.',
                                    );
                                    return;
                                }
                                this.api
                                    .post(this.apiBaseUrl + 'biosicherheitsplan_rind/duplicate.php', {
                                        bs_id: value?.bs_id,
                                        ziel_kunde_id: client.kunde_id,
                                    })
                                    .subscribe({
                                        next: (res: { bs_id?: number }) => {
                                            this.api.reload();
                                            const newBsId = Number(res?.bs_id || 0);
                                            if (newBsId > 0) {
                                                bspRindSetSkipPlanOeffnenBestaetigung(newBsId);
                                                this.router.navigate(['belege/biosicherheitsplanrind/' + newBsId]).then();
                                            } else {
                                                this.messageService.infoMessage(
                                                    'Plan wurde dupliziert. Bitte öffnen Sie den neuen Plan in der Übersicht.',
                                                );
                                            }
                                        },
                                        error: error =>
                                            this.messageService.errorMessage(
                                                'Fehler beim Duplizieren des Bio-Sicherheitsplans',
                                                error,
                                            ),
                                    });
                            },
                        });
                    }
                },
            });
    }
}
